import { MenuOptionType } from "@dexteel/mesf-core";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import PlaylistAddIcon from "@mui/icons-material/PlaylistAdd";

import { Section } from "../../../models/Section";

type Props = {
	setSelectedRowData: (section: Section) => void;
	setShowModal: (modal: "create" | "update" | "delete" | "") => void;
	handleNewSection: () => void;
};
export const useSectionOptionsFunctions = ({
	setSelectedRowData,
	setShowModal,
	handleNewSection,
}: Props) => {
	const getMenuOptions = (data: Section) => {
		let options: MenuOptionType[] = [];
		options = options.concat([
			{
				name: "New Section",
				key: "new_section",
				onClick: () => {
					handleNewSection();
				},
				icon: <PlaylistAddIcon />,
			},
		]);
		if (data) {
			options = options.concat([
				{
					name: "Edit Section",
					key: "edit_section",
					onClick: () => {
						setSelectedRowData(data);
						setShowModal("update");
					},
					icon: <EditIcon />,
				},
				{
					name: "Delete Section",
					key: "delete_section",
					onClick: () => {
						setSelectedRowData(data);
						setShowModal("delete");
					},
					icon: <DeleteIcon />,
				},
			]);
		}
		return options;
	};
	return {
		getMenuOptions,
	};
};
